import { createContext } from "react";

const ContextFile = createContext();

export default ContextFile